// extracted by mini-css-extract-plugin
module.exports = {"links":"link-list-links--f24fb","skip":"link-list-skip--9d091"};